module.exports = __webpack_public_path__ + "static/media/plus-ic.c28eebfd.svg";